// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'apikeys'"
        editRoute="apikeyEdit"
        :headers="headers"
        id="_id"
        name="API Key"
        :searchBarText="searchBarText"
        permissions="apikeys"
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'

import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Token',
          value: 'token'
        },
        {
          text: 'Locked',
          value: 'locked',
          type: 'checkbox'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ApiKeys.vue